import React from 'react';
import { useCurrentUser } from '@klp/auth';
import { AuthRoutes } from '@klpkonsern/auth-core/routes';
import { Tooltip } from '@klp/design';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { Hidden, IconButton } from '@material-ui/core';
import { useHistory } from 'react-router';
export const HeaderToolbarLogout = () => {
    const { currentUser, currentUserIsLoading } = useCurrentUser();
    const history = useHistory();

    const handleLogout = () => {
        history.replace(AuthRoutes.logout);
    };

    if (currentUserIsLoading) return null;
    if (!currentUser) return null;

    return (
        <Hidden xsDown={true}>
            <Tooltip translation="auth.logout" title="">
                <IconButton onClick={handleLogout} color="secondary">
                    <Illustration icon={IconName.LOGOUT} klpColor="main" />
                </IconButton>
            </Tooltip>
        </Hidden>
    );
};
